import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { ProductVoucherInteractiveLabelDialog } from './ProductVoucherInteractiveLabelDialog'
import { useProductVoucherLabelInteractiveControls } from './useProductVoucherLabelInteractiveControls'

const PLUS = '+'

type ProductVoucherInteractiveLabelProps = {
  legalText?: string
  voucher: string
}

export const ProductVoucherInteractiveLabel: FC<
  ProductVoucherInteractiveLabelProps
> = ({ legalText, voucher }) => {
  const { closeDialog, isDialogOpen, openDialog } =
    useProductVoucherLabelInteractiveControls()

  return (
    <>
      <ProductVoucherInteractiveLabelDialog
        isOpen={isDialogOpen}
        legalText={legalText}
        onClose={closeDialog}
        voucher={voucher}
      />

      <button
        className="flex items-center gap-1 whitespace-nowrap rounded-full bg-light-tertiary px-3 py-1 text-xs"
        data-qa-id="product-voucher-explainer-trigger"
        onClick={openDialog}
        type="button"
      >
        <span>
          <span aria-hidden>{PLUS}</span>
          <FormattedMessage id="product.label.voucher" />
        </span>
        <IconInfo />
      </button>
    </>
  )
}
